import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ViewReceipt.css';

//Component
import Receipt from '../../Receipt';

class ViewReceipt extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired
  };

  render() {
    const { data, title } = this.props;

    return (
      <div className={cx("print-sideAdminPageWrapper", "print-noMargin")}>
        <h1 className={cx(s.siteAdminHeading, "hidden-print")}>{title}</h1>
        <Receipt data={data} />
      </div>
    );
  }

}

export default withStyles(s)(ViewReceipt);



